var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpensifyLogoStaging = function SvgExpensifyLogoStaging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#03D47C",
    viewBox: "0 0 162 34",
    style: {
      enableBackground: "new 0 0 162 34"
    },
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "expensify-logo--staging_svg__a",
    d: "M0 0h162v34H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "expensify-logo--staging_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#expensify-logo--staging_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#expensify-logo--staging_svg__b)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.9h16v-4.7H5.9v-4.4H14V12H5.9V7.8H16V3.1H0v22.8zM35.9 8.1h-7l-2.3 4.3L24 8.1h-7.2l5.9 8.6-6.3 9.2h7l2.8-4.8 2.8 4.8h7.2L30 16.7l5.9-8.6zM47 7.7c-1.9 0-3.6.8-4.9 2.3V8.1h-5.4v25.3h5.7v-8.9c1 1.1 2.6 1.8 4.5 1.8 4.7 0 8-3.6 8-9.3 0-5.7-3.1-9.3-7.9-9.3zm-1.3 13.9c-2.2 0-3.4-1.7-3.4-4.6s1.3-4.6 3.4-4.6c2.2 0 3.4 1.7 3.4 4.6 0 2.9-1.2 4.6-3.4 4.6zM65 21.8c-1.8 0-3.1-1-3.4-3.6h12.3v-.8c0-5.5-3.1-9.8-9.1-9.8-4.2 0-9.1 2.3-9.1 9.3 0 5.7 3.7 9.3 9.3 9.3 3.4 0 7.6-1.2 8.9-6.5h-5.8c-.3 1.1-1 2.1-3.1 2.1zm-.2-9.9c1.7 0 2.8.9 2.9 3h-6c.5-2.3 1.7-3 3.1-3zM85.1 7.7c-2 0-3.7.9-4.9 2.5V8.1h-5.4v17.8h5.7V16c0-2.4 1.2-3.4 2.8-3.4 1.7 0 2.7.7 2.7 3.4v9.9h5.7V15.5c.1-5.6-2.2-7.8-6.6-7.8zM112.8 0c-1.8 0-3 1.3-3 2.9s1.3 3 3 3c1.8 0 3-1.3 3-3s-1.2-2.9-3-2.9zM115.7 8.1H110v17.7h5.7V8.1zM102.4 14.8l-1.4-.3c-1.5-.3-2-1-2-1.7 0-1 .8-1.6 2.2-1.6 1.7 0 2.6.5 2.6 2.2h5c-.1-3.7-2.3-5.9-7.8-5.9-4.7 0-7.6 1.8-7.6 5.7 0 3.1 2.1 4.5 6.9 5.6l1.4.3c1.5.3 2 1 2 1.7 0 1-.9 1.4-2.4 1.4-2 0-2.9-.7-3.1-2.4h-5.6c.3 4.3 3.3 6.4 8.5 6.4s8.3-1.9 8.3-5.9c-.1-3-2.2-4.4-7-5.5zM138.2 8.1 134.9 19l-3.2-10.8h-7.4v-.6c0-1.4 1.1-2.9 2.8-2.9h.8V0h-1.2c-4.9.1-8.2 3.6-8.2 7.9v.2h-2.2v5.2h2.2v12.5h5.7V13.4h3.2l4.3 12-.7 1.9c-.5 1.4-1.1 1.8-2.3 1.8-.6 0-1.2 0-2.1-.3l-.4 4.7c.9.3 1.9.4 3.3.4 3.4 0 5.2-1.5 7-6L144 8.1h-5.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147 19.9h9c3.3 0 6 2.7 6 6s-2.7 6-6 6h-9c-3.3 0-6-2.7-6-6s2.7-6 6-6z",
    style: {
      fill: "#008c59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 28.1c1 0 1.7-.4 1.7-1.3 0-.7-.4-1-1.3-1.2l-.6-.1c-.5-.1-.7-.2-.7-.5s.3-.5.7-.5c.5 0 .8.2.8.6h.8c0-.8-.6-1.4-1.7-1.4s-1.6.6-1.6 1.2c0 .7.4 1 1.3 1.2l.6.1c.5.1.7.3.7.5 0 .4-.3.5-.8.5-.6 0-.9-.2-.9-.7h-.8c0 1.1.7 1.6 1.8 1.6zm3.9-.1v-3.4h1.2v-.8h-3.3v.8h1.2V28h.9zm1.5-2.1c0 1.3.8 2.2 2 2.2 1.1 0 2-.8 2-2.1v-.2H155v.7h1c-.1.6-.5.8-1.1.8-.7 0-1.2-.6-1.2-1.4s.5-1.4 1.2-1.4c.5 0 .9.2 1.1.7h.9c-.2-.9-.9-1.5-1.9-1.5-1.3.1-2.1 1-2.1 2.2z",
    style: {
      fill: "#e7ece9"
    }
  })));
};
export default SvgExpensifyLogoStaging;